import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import TivityLogo from './TivityLogo';

const CONTACT_EMAIL = 'contact-tivity@tivity.fr';

function Footer() {
    const { t } = useTranslation();

    return (
        <Box
            component="footer"
            sx={{
                bgcolor: 'grey.50',
                borderTop: 1,
                borderColor: 'divider',
            }}
        >
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    spacing={2}
                >
                    <Box>
                        <TivityLogo size={24} />
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                            {t('footer.copyright', { year: new Date().getFullYear() })}
                        </Typography>
                    </Box>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 3 }}>
                        <Link component={RouterLink} to="/mentions-legales" underline="hover" color="text.secondary" variant="body2">
                            {t('footer.legalNotice')}
                        </Link>
                        <Link component={RouterLink} to="/confidentialite" underline="hover" color="text.secondary" variant="body2">
                            {t('footer.privacyPolicy')}
                        </Link>
                        <Link component={RouterLink} to="/cgu" underline="hover" color="text.secondary" variant="body2">
                            {t('footer.termsOfUse')}
                        </Link>
                        <Link href={`mailto:${CONTACT_EMAIL}`} underline="hover" color="text.secondary" variant="body2">
                            {t('footer.contact')}
                        </Link>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}

export default Footer;
